import React from 'react';
import { Award, Star } from 'lucide-react';
import { certifications } from '../mockData';
import { Card, CardContent } from './ui/card';

const gradients = [
  'from-cyan-500 to-blue-500',
  'from-purple-500 to-pink-500',
  'from-blue-500 to-indigo-500',
  'from-orange-500 to-red-500'
];

const bgGradients = [
  'from-cyan-50 to-blue-50',
  'from-purple-50 to-pink-50',
  'from-blue-50 to-indigo-50',
  'from-orange-50 to-red-50'
];

const Certifications = () => {
  return (
    <section id="certifications" className="py-20 bg-gradient-to-br from-white via-blue-50/30 to-purple-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-transparent bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text font-bold text-sm uppercase tracking-wider">Credentials</span>
          <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-orange-800 to-red-900 bg-clip-text text-transparent mt-2">Certifications & Licenses</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-lg">
            Recognized qualifications ensuring the highest standards of care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <Card key={cert.id} className={`border-2 border-purple-200 shadow-xl hover:shadow-2xl transition-all duration-300 group hover:-translate-y-2 bg-gradient-to-br ${bgGradients[index]}`}>
              <CardContent className="p-6 space-y-4 relative overflow-hidden">
                {/* Decorative star */}
                <Star className="absolute top-2 right-2 h-6 w-6 text-yellow-400 fill-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-spin" style={{ animationDuration: '3s' }} />
                
                <div className={`bg-gradient-to-br ${gradients[index]} w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300`}>
                  <Award className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{cert.title}</h3>
                  <p className="text-gray-700 text-sm mb-1 font-medium">{cert.organization}</p>
                  <p className={`bg-gradient-to-r ${gradients[index]} bg-clip-text text-transparent text-sm font-bold`}>{cert.year}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;